var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneFlip2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.956 38.8271L450.556 19.4137C424.743 -6.39962 382.93 -6.39962 357.116 19.4137C356.476 20.0537 317.01 71.467 317.01 71.467C292.69 97.0671 292.69 137.387 317.01 162.774L341.756 193.92C310.61 264.534 262.183 313.174 193.916 342.187L162.77 317.227C137.383 292.694 96.8495 292.694 71.4628 317.227C71.4628 317.227 20.0495 356.694 19.4095 357.334C-6.40383 383.147 -6.40383 424.96 18.3428 449.707L39.6762 474.24C64.2095 498.774 97.2762 512.214 133.116 512.214C296.103 512.214 511.996 296.107 511.996 133.334C511.996 97.7071 498.556 64.4271 472.956 39.0404V38.8271ZM133.116 469.334C108.796 469.334 86.3962 460.374 71.0362 444.8L49.7028 420.267C40.9562 411.52 40.5295 397.227 48.8495 388.054C48.8495 388.054 99.8362 348.8 100.476 348.16C109.223 339.414 124.583 339.414 133.543 348.16C134.183 348.8 177.063 383.147 177.063 383.147C183.036 387.84 190.93 389.12 197.97 386.347C286.29 352.64 349.65 289.494 386.13 198.4C388.903 191.36 387.836 183.254 382.93 177.067C382.93 177.067 348.583 133.974 348.156 133.547C338.983 124.374 338.983 109.654 348.156 100.48C348.796 99.8404 388.05 48.8537 388.05 48.8537C397.223 40.5337 411.516 40.747 421.33 50.5604L443.73 69.9737C460.156 86.4004 469.33 108.8 469.33 133.12C469.33 281.6 260.903 469.334 133.116 469.334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFlip2);
export default __webpack_public_path__ + "static/media/phone-flip 2.be6e58e15ebd31e96a41dcc255838a4c.svg";
export { ForwardRef as ReactComponent };